import * as Sentry from '@sentry/react'

export function initSentry() {
  if (process.env.REACT_APP_SENTRY_DSN) {
    // only for production env
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: false,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ['error'] }),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/mitra\.pasarpolis\.io\/agency/,
        /^https:\/\/mitra\.ppibroker\.com\/agency/,
      ],
      // Enable logs to be sent to Sentry
      enableLogs: true,
    })
  }
}
